import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentWaybillGoodsItemsFacade } from './shipment-waybill-goods-items.facade';
import { ShipmentWaybillGoodsItemListSearchCriteria } from '../../models/shipment-waybill-goods-items.model';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillGoodsItemsGuard {
  constructor(
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
    private shipmentWaybillGoodsItemsFacade: ShipmentWaybillGoodsItemsFacade,
  ) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentWaybillGoodsItemsFacade, new ShipmentWaybillGoodsItemListSearchCriteria());
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillGoodsItemsFacade);
  }
}
